import { render, staticRenderFns } from "./comp_WhatsappBtn.vue?vue&type=template&id=e52e658e&scoped=true"
import script from "./comp_WhatsappBtn.vue?vue&type=script&lang=js"
export * from "./comp_WhatsappBtn.vue?vue&type=script&lang=js"
import style0 from "./comp_WhatsappBtn.vue?vue&type=style&index=0&id=e52e658e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52e658e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
